var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderTitle',{attrs:{"username":_vm.userName,"toptype":_vm.topType}}),_vm._v(" "),_c('section',{staticClass:"banner_div word"},[_c('SuccessBox',{attrs:{"stitle":_vm.sTitle}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('PageFooter')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cac08ba0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pay/Pay.vue
// module id = null
// module chunks = 